/* Doku: https://dixonandmoe.com/rellax/ */

function initParallax(){
    let rellaxHeroImageBg = '.hero-background-image';
    let rellaxParallaxBg = '.frame-container.parallaxBg .rellax-img';
    if ($(rellaxParallaxBg).length > 0) {
        var rellax = new Rellax(rellaxParallaxBg, {
            center: true
        });
    }
    if ($(rellaxHeroImageBg).length > 0) {
        var rellaxHeroImage = new Rellax(rellaxHeroImageBg, {
            center: true
        });
    }
}
